import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${string}/fieldReportCard`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/fieldReportCard`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/${workOrderId}/fieldReportCard`;
